'use client'

import createDOMPurify, { DOMPurify } from 'dompurify'
import { useEffect, useState } from 'react'

const ALLOWED_TAGS = [
  'a',
  'abbr',
  'address',
  'article',
  'aside',
  'b',
  'bdi',
  'bdo',
  'blockquote',
  'br',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'data',
  'dd',
  'dfn',
  'div',
  'dl',
  'dt',
  'em',
  'figcaption',
  'figure',
  'footer',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hgroup',
  'hr',
  'i',
  'kbd',
  'li',
  'main',
  'mark',
  'nav',
  'ol',
  'p',
  'pre',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'section',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'time',
  'tr',
  'u',
  'ul',
  'var',
  'wbr',
]

const ALLOWED_ATTR = ['href', 'name', 'target', 'rel']

function applyAttrPolicy(purifier: ReturnType<typeof createDOMPurify>) {
  purifier.addHook('afterSanitizeAttributes', node => {
    if (node.nodeName === 'A') {
      const target = node.getAttribute('target')
      if (target && target.toLowerCase() !== '_self') {
        node.setAttribute('rel', 'noopener noreferrer')
      }
    }
  })
}

let purifier: DOMPurify | null = null

export function SafeHtml({ unsafeHtml, ...props }: { unsafeHtml: string }) {
  const [sanitizedHtml, setSanitizedHtml] = useState<string | null>(null)

  useEffect(() => {
    if (!purifier) {
      purifier = createDOMPurify(window)
      applyAttrPolicy(purifier)
    }

    setSanitizedHtml(
      purifier.sanitize(unsafeHtml, { ALLOWED_TAGS, ALLOWED_ATTR }),
    )
  }, [unsafeHtml])

  if (sanitizedHtml === null) {
    return null
  }

  return <span {...props} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
}
